import { CountryCode } from "../types";

const masksByCountryCode: Record<
  CountryCode,
  Record<"landline" | "mobile", Record<"international" | "national", string>>
> = {
  ID: {
    landline: {
      international: "+62000 0000 00000",
      national: "\\0000 0000 00000",
    },
    mobile: {
      international: "+62800 0000 00000",
      national: "\\0800 0000 00000",
    },
  },
};

export type PhoneMaskFormat = "national" | "international";
export type PhoneMaskType = "landline" | "mobile";

export type GetPhoneMaskParams = {
  countryCode?: CountryCode;
  format?: PhoneMaskFormat;
  type?: PhoneMaskType;
};

export const getPhoneMask = ({
  countryCode = CountryCode.ID,
  type = "mobile",
  format = "national",
}: GetPhoneMaskParams = {}) => {
  return masksByCountryCode[countryCode][type][format];
};

export const formatPhoneNumber = (phoneNumber: string): string => {
  const rawValue = phoneNumber.replace(/[-_ ]/g, "");
  return rawValue.replace(/^0/, "+62");
};
